// extracted by mini-css-extract-plugin
export default {"usersTable":"stylev2_usersTable__m4AUx"};